import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getContentDetails } from "../../../../redux/actions/campaignActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
import "../../../../components/common/css/add.scss";

const ContentView = () => {
  let token = localStorage.getItem("accessToken");
  const [loading, setLoading] = useState(false);
  const id = useParams();

  const dispatch = useDispatch();
  const contentView = useSelector((state) => state.contentView);
  const { content } = contentView;

  useEffect(() => {
    dispatch(getContentDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (contentView) {
      if (contentView?.loading !== undefined) {
        setLoading(contentView?.loading);
      }
    }
  }, [contentView]);

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="bottom">
          <div className="modal-content">
            <div className="modal-content-title">View Content</div>
            <p>&nbsp;</p>
            <form>
              <div className="custome-form-group">
                <label>Page Title English</label>
                <input
                  type="text"
                  name="name"
                  value={content?.data?.page_title_en}
                  disabled={true}
                  placeholder="Enter Category Name"
                  className="custome-input"
                />
              </div>
              <div className="custome-form-group">
                <label>Page Title French</label>
                <input
                  type="text"
                  name="name"
                  value={content?.data?.page_title_fr}
                  disabled={true}
                  placeholder="Enter Category Name"
                  className="custome-input"
                />
              </div>
              <div className="custome-form-group">
                <label>Page Title Italian</label>
                <input
                  type="text"
                  name="name"
                  value={content?.data?.page_title_it}
                  disabled={true}
                  placeholder="Enter Category Name"
                  className="custome-input"
                />
              </div>
              <div className="custome-form-group">
                <label>Page Title Spanish</label>
                <input
                  type="text"
                  name="name"
                  value={content?.data?.page_title_es}
                  disabled={true}
                  placeholder="Enter Category Name"
                  className="custome-input"
                />
              </div>
              <div className="custome-form-group">
                <label>Page Title Polish</label>
                <input
                  type="text"
                  name="name"
                  value={content?.data?.page_title_pl}
                  disabled={true}
                  placeholder="Enter  Tittle"
                  className="custome-input"
                />
              </div>
              <div className="custome-form-group">
                <label>Page Slug</label>
                <input
                  type="text"
                  name="name"
                  value={content?.data?.slug}
                  disabled={true}
                  placeholder="Enter Slug Name"
                  className="custome-input"
                />
              </div>
              <div className="custome-form-group">
                <label>Page Content English</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content?.data?.page_content_en}
                  name="aboutcontent_en"
                  disabled={true}
                />
              </div>
              <div className="custome-form-group">
                <label>Page Content French</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content?.data?.page_content_fr}
                  name="aboutcontent_fr"
                  disabled={true}
                />
              </div>
              <div className="custome-form-group">
                <label>Page Content Italian</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content?.data?.page_content_it}
                  name="aboutcontent_it"
                  disabled={true}
                />
              </div>
              <div className="custome-form-group">
                <label>Page Content Spanish</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content?.data?.page_content_es}
                  name="aboutcontent_it"
                  disabled={true}
                />
              </div>
              <div className="custome-form-group">
                <label>Page Content Polish</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content?.data?.page_content_pl}
                  name="aboutcontent_it"
                  disabled={true}
                />
              </div>
              {/* <button type="submit" className="approveButton">
                Save
              </button> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentView;
